<style lang="less">
@import '../../../../../stylesheet/variable.less';

.order-recommend-goods {
  font-size: 15px;
  background: #fff;
  .recommend-title {
    height: 49px;
    line-height: 49px;
    text-align: center;
    position: relative;
    &:after {
      .setBottomLine();
    }
  }
  .recommend-list {
    background: #fff;
    @media (max-width: 375px) and (min-width: 320px) {
      width: 100%;
      padding: 10px 0 0;
    }
    @media (min-width: 375px) {
      padding: 10px 7.5px 0 7.5px;
    }
    .recommend-item {
      float: left;
      width: 50%;
      .item-wrap {
        width: calc(~'100% - 15px');
        margin: 5px 7.5px;
        display: inline-block;
        position: relative;
        @media (max-width: 375px) and (min-width: 320px) {
          height: 190px;
        }
        @media (min-width: 375px) {
          height: 225px;
        }
        .img-wrap {
          @media (max-width: 375px) and (min-width: 320px) {
            width: 142.5px;
            height: 142.5px;
            margin: 0 auto;
          }
          @media (min-width: 375px) {
            width: 165px;
            height: 165px;
            margin: 0 auto;
          }
          display: flex;
          justify-content: flex-start;
          align-items: center;
        }
        .item-describe {
          @media (max-width: 375px) and (min-width: 320px) {
            width: 142.5px;
            margin: 0 auto;
          }
          @media (min-width: 375px) {
            width: 165px;
            margin: 0 auto;
          }

          padding-top: 13px;
          line-height: 17px;
          .masterName {
            display: inline-block;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            top: 0;
            left: 0;
            font-size: 15px;
            color: rgb(25, 26, 27);
          }
          .price {
            font-size: 15px;
            color: rgb(255, 95, 22);
            .decimal {
              font-size: 10px;
            }
            i {
              font-size: 11px;
              font-style: normal;
            }
          }
          .market-price {
            text-decoration: line-through;
            font-size: 11px;
            color: rgb(189, 192, 197);
          }
          .salesCount {
            font-size: 11px;
            color: rgb(189, 192, 197);
          }
        }
      }
    }
  }
}
</style>
<template>
  <div class="order-recommend-goods">
    <div class="recommend-title">猜你喜欢</div>
    <div class="recommend-list clearfix">
      <div :key="item.id" v-for="(item, index) in recommendList" class="recommend-item" @click="toProduct(item.productId)">
        <div class="item-wrap">
          <div class="img-wrap">
            <lazy-img width="100%" height="100%" :src="item.sku.imgUrl"></lazy-img>
          </div>
          <div class="item-describe">
            <span class="masterName">{{ item.masterName }}</span>
            <decimal-price :price="item.sku.price" myclz="price"></decimal-price>
            <span v-if="isShowMarketPrice(item.sku.marketPrice)" class="market-price">￥{{ item.sku.marketPrice | price }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ORDERCONSTANT from '../../../../constant/order'
import lazyImg from '../../../../components/lazy-img'
import icon from '../../../../components/icon'
import decimalPrice from '../../../../components/decimal-price'
import { priceConversion } from '../../../../util/function'
import { InfiniteScroll, Spinner } from 'mint-ui'
export default {
  data() {
    return {}
  },
  components: {
    icon,
    'lazy-img': lazyImg,
    'decimal-price': decimalPrice
  },
  directives: {
    InfiniteScroll
  },
  mounted() {
    this.$store.dispatch('getRecommendByOrder', {
      pageSize: 0,
      pageNum: 0,
      payOrderId: this.id,
      orderId: [this.id]
    })
  },
  computed: {
    id: context => {
      return context.$route.params.id
    },
    recommendList: context => {
      return context.$store.getters[ORDERCONSTANT.ORDER_GETTER_RECOMMEND_LIST].list || []
    },
    isShowMarketPrice: context => {
      return price => price !== 0
    }
  },
  methods: {
    toProduct(productId) {
      this.$router.push({ name: 'itemDetail', params: { id: productId } })
    }
  }
}
</script>
